<template>
	<el-dialog :title="showTitle" :visible.sync="dialogAddShow" width="80%" :before-close="handleClose"
	:close-on-click-modal="false">
		<el-form label-position="right" ref="addForm" :model="addForm" label-width="70px" class="postForm">
			<el-row>
				<el-col :span="12">
					<el-form-item label="题目分组:" label-width="110px" class="notBlank">
						<el-cascader style="height: auto;" class="formItem300 el-cascader-menu" size="small"
							:options="treeData" :props="defaultProps" v-model="selectedGroupOptions"
							@change="handleGroupChange">
						</el-cascader>
					</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="难易度:" label-width="110px" class="notBlank">
						<el-select v-model="addForm.proLevel" placeholder="请选择" size="small" class="formItem150">
							<el-option v-for="item in proLevelDict" :key="item.valuekey" :label="item.textkey"
								:value="item.valuekey">
							</el-option>
						</el-select>
					</el-form-item>
					</el-col>
				</el-row>
			<el-row>
				<el-col :span="12">
					<el-form-item label="题目类型:" label-width="110px" class="notBlank">
				<el-select v-model="addForm.proType" placeholder="请选择" size="small">
					<el-option v-for="item in proTypeDict" :key="item.valuekey" :label="item.textkey"
						:value="item.valuekey">
					</el-option>
				</el-select>
			</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="教材版本:" label-width="110px" class="notBlank">
						<el-select v-model="bookVersionArr" placeholder="请选择" size="small" style="width: 100%;" multiple="" filterable>
							<el-option v-for="item in bookVersionDict" :key="item.valuekey" :label="item.textkey"
								:value="item.valuekey">
							</el-option>
						</el-select>
					</el-form-item>
	
				</el-col>
			</el-row>
			<el-form-item label="题目:" label-width="110px" class="notBlank">
				<tinymce id="tinymceId_0" ref="editor" v-model="addForm.proRemark" :height="130"></tinymce>
				<div v-if="(String(addForm.proType) == '0' || String(addForm.proType) == '1')">注：如果题目包含备选答案，以下备选答案可以不用填写！</div>
			</el-form-item>
			<el-form-item label="题目名:" label-width="110px" class="notBlank" v-if="1 == 2">
				<el-input v-model="addForm.proName" auto-complete="off" class="formItem350" size="small"
					maxLength="200" />
			</el-form-item>
			<el-row :style="{display:(String(addForm.proType) == '0' || String(addForm.proType) == '1')?'block':'none'}">
				<el-col :span="12">
					<el-form-item label="备选答案A:" label-width="110px">
						<tinymce id="tinymceId_select0" ref="editor0" v-model="selectAnswerList[0].value" :height="100"></tinymce>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="备选答案B:" label-width="110px">
						<tinymce id="tinymceId_select1" ref="editor1" v-model="selectAnswerList[1].value" :height="100"></tinymce>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :style="{display:(String(addForm.proType) == '0' || String(addForm.proType) == '1')?'block':'none'}">
				<el-col :span="12">
					<el-form-item label="备选答案C:" label-width="110px">
						<tinymce id="tinymceId_select2" ref="editor2" v-model="selectAnswerList[2].value" :height="100"></tinymce>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="备选答案D:" label-width="110px">
						<tinymce id="tinymceId_select3" ref="editor3" v-model="selectAnswerList[3].value" :height="100"></tinymce>
					</el-form-item>
				</el-col>
			</el-row>


			<el-form-item label="正确答案:" label-width="110px" class="notBlank"
				v-if="String(addForm.proType) == '0' || String(addForm.proType) == '1'">
				<el-select v-model="isAnswerArr" placeholder="请选择" size="small" class="formItem250" multiple
					:multiple-limit="String(addForm.proType) == '0' ? 1 : 4">
					<el-option v-for="item in selectAnswerList" :key="item.label" :label="item.label"
						:value="item.label">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="填空答案:" label-width="110px" class="notBlank" v-if="String(addForm.proType) == '2'">
				<div style="background-color: #F8F8F9;padding: 5px;margin-top:5px">
					<el-button type="primary" icon="el-icon-circle-plus-outline" plain size="mini"
						@click="addTableRow">新增一行</el-button>
				</div>
				<div>
					<el-table :data="inputAnserList" height="250px" border highlight-current-row style="width: 100%;"
						:header-cell-style="{ height: '30px' }">
						<el-table-column type="index" width="55" label="序号"></el-table-column>
						<el-table-column prop="optionAnswer" label="答案" width="200">
							<template scope="scope">
								<el-input v-model="scope.row.optionAnswer" auto-complete="off" size="small"
									maxLength="150" />
							</template>
						</el-table-column>
						<el-table-column label="操作" width="100">
							<template scope="scope">
								<el-button size="small" @click="delInfo(scope.$index, scope.row)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-form-item>
			<el-form-item label="填空答案:" label-width="110px" class="notBlank" v-if="String(addForm.proType) == '3'">
				<div style="background-color: #F8F8F9;padding: 5px;margin-top:5px">
					<el-button type="primary" icon="el-icon-circle-plus-outline" plain size="mini"
						@click="addTableRow">新增一行</el-button>
				</div>
				<div>
					<el-table :data="inputAnserList" height="250px" border highlight-current-row style="width: 100%;"
						:header-cell-style="{ height: '30px' }">
						<el-table-column type="index" width="55" label="序号"></el-table-column>
						<el-table-column prop="optionAnswer" label="答案(分子/分母)" width="200">
							<template scope="scope">
								<el-input v-model="scope.row.optionAnswerArr[0]" auto-complete="off" size="small" type="Number" style="width:60px"
									maxLength="150" /> /
									<el-input v-model="scope.row.optionAnswerArr[1]" auto-complete="off"  type="Number" size="small" style="width:60px"
									maxLength="150" />
							</template>
						</el-table-column>
						<el-table-column label="操作" width="100">
							<template scope="scope">
								<el-button size="small" @click="delInfo(scope.$index, scope.row)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="handleClose()" size="small">取 消</el-button>
			<el-button type="primary" @click="handleSubmit(1)" size="small">保 存</el-button>
			<!-- <el-button type="primary" @click="handleSubmit(2)" size="small"  v-if="mid<=0">保存继续</el-button> -->
		</div>
	</el-dialog>
</template>
<script>

import tinymce from '@/components/tinymce/index.vue'
export default {
	name: "addSave",
	props: ["showTitle", "dialogAddShow", "mid","fromType"],
	components: { tinymce },
	data() {
		return {
			addForm: {
				id: 0,
				proType: '',
				proNo: '',
				proName: '',
				proRemark: '',
				proLevel: '',
				proScores: 0,
				judge_Istrue: 0,
				gradeId: 0,
				unitId: 0,
				lorePointId: 0,
				chapterId:0,
				courseId: 0,
				proAnalysis: "",
				addTime: '',
				schoolId: 0,
				status: 1,
				fromType:1,
				detailList: [],
				bookversionList:[]
			},
			proTypeDict: [],
			proLevelDict: [],
			bookVersionDict:[],
			bookVersionArr:[],
			treeData: [],
			selectedGroupOptions: [],
			defaultProps: {
				children: "children",
				label: "groupName",
				value: "id",
			},
			selectAnswerList: [{ value: '', label: 'A' }, { value: '', label: 'B' }, { value: '', label: 'C' }, { value: '', label: 'D' }],
			isAnswerArr: [],
			inputAnserList: []
		};
	},
	watch: {
		dialogAddShow: {
			handler(newVal, oldVal) {
				if (newVal) {
					this.initData();
				}
			},
			deep: true
		}
	},
	methods: {
		handleGroupChange(value) {
			this.addForm.gradeId = 0
			this.addForm.unitId = 0
			this.addForm.lorePointId = 0
			this.addForm.chapterId=0
			if (value.length > 0) {
				this.addForm.gradeId = value[0]
			}
			if (value.length > 1) {
				this.addForm.unitId = value[1]
			}
			if (value.length > 2) {
				this.addForm.chapterId = value[2]
			}
		},
		addTableRow() {
			this.inputAnserList.push(
				{
					id: 0,
					proId: 0,
					proIndex: 0,
					optionAnswer: '',
					isAnswer: 0,
					optionAnswerArr:["",""]
				});
		},
		delInfo(index, row) {
			this.inputAnserList.splice(index, 1)
		},
		initData() {
			try{
			this.isAnswerArr = []
			this.inputAnserList = []
			this.selectAnswerList = [{ value: '', label: 'A' }, { value: '', label: 'B' }, { value: '', label: 'C' }, { value: '', label: 'D' }]
			this.selectedGroupOptions = []
			let that=this
			this.$axios.get("/exercise/getexerciseinfoinfo?id=" + this.mid + "&rnd=" + new Date().getTime())
				.then(res => {
					this.addForm = res.data.data;
					if (this.addForm.id <= 0) {
						this.addForm.proLevel = ''
						this.addForm.proType = ''
						this.addForm.gradeId = 0
						this.addForm.unitId = 0
						this.addForm.lorePointId = 0
						this.addForm.proRemark = ''
						this.addForm.proAnalysis = ''
						this.addForm.fromType=this.fromType
						this.addForm.bookversionList=[]
						this.bookVersionArr=[]
						this.addTableRow()
						//window.MathJax.typesetPromise([this.$refs.addForm])
						that.$nextTick(()=>{
							that.$refs["editor"].setContent("")
							that.$refs["editor0"].setContent("")
							that.$refs["editor1"].setContent("")
							that.$refs["editor2"].setContent("")
							that.$refs["editor3"].setContent("")
						})

					}
					else {
						this.selectedGroupOptions = [this.addForm.gradeId, this.addForm.unitId,this.addForm.chapterId]
						this.bookVersionArr=this.addForm.bookversionList.map(v=>{return v.bookVersionId})
						if (this.addForm.proType == 2) {//填空题
							this.addForm.detailList.map((v, index) => {
								this.inputAnserList.push({
									id: v.id,
									proId: 0,
									proIndex: v.proIndex,
									optionAnswer: v.optionAnswer,
									isAnswer: 1,
									optionAnswerArr:["",""]
								})
							})
						}
						else if (this.addForm.proType == 3) {//分数题
							this.addForm.detailList.map((v, index) => {
								this.inputAnserList.push({
									id: v.id,
									proId: 0,
									proIndex: v.proIndex,
									optionAnswer: v.optionAnswer,
									optionAnswerArr:v.optionAnswer.split('/'),
									isAnswer: 1,
								})
							})
						}
						else if (this.addForm.proType == 1 || this.addForm.proType == 0) {
							this.addTableRow()
							this.addForm.detailList.map((v, index) => {
								this.selectAnswerList[index]={
									value: v.optionAnswer,
									label: v.proIndex
								}
								if (v.isAnswer == 1) {
									this.isAnswerArr.push(v.proIndex)
								}
								that.$nextTick(()=>{
									if(that.$refs["editor"+index]){
										that.$refs["editor"+index].setContent(v.optionAnswer)
									}
								})
							})
							
						}
					}
					this.$nextTick(()=>{
						if(that.$refs.editor){
							that.$refs.editor.setContent(that.addForm.proRemark)
						}
					})
				});
			}
			catch(e){
				this.$message("加载题目出错!"+e);
			}
			
		},
		hanleClear(){
			//alert(this.$refs.editor2)
			this.addForm.proRemark = ''
			this.addForm.proAnalysis = ''
			this.$refs.editor.setContent(this.addForm.proRemark)
			//this.$refs.editor2.setContent(this.addForm.proAnalysis)
		},
		handleClose() {
			this.hanleClear()
			this.$emit("getVisible", false);
		},
		handleSubmit(addType) {
			if (String(this.addForm.proType) == '') {
				this.$message("请选持题目类型!");
				return
			}
			let detailList = []
			if (String(this.addForm.proType) == '0' || String(this.addForm.proType) == '1') {
				// if (this.selectAnswerList.filter(v => v.value == '').length > 0) {
				// 	this.$message("备选答案不能为空!");
				// 	return
				// }
				if (this.isAnswerArr == null || this.isAnswerArr.length == 0) {
					this.$message("正确答案不能为空!");
					return
				}
				this.selectAnswerList.map((v, index) => {
					detailList.push({
						id: 0,
						proId: 0,
						proIndex: v.label,
						optionAnswer: v.value,
						isAnswer: this.isAnswerArr.includes(v.label) ? 1 : 0,
					})
				})
			}
			else  {
				if (this.inputAnserList.length == 0) {
					this.$message("正确答案不能为空!");
					return
				}
				this.inputAnserList.map((v, index) => {
					if (String(this.addForm.proType) == '2'){
						detailList.push({
						id: 0,
						proId: 0,
						proIndex: index + 1,
						optionAnswer: v.optionAnswer,
						isAnswer: 1
						})
					}
					else{
						detailList.push({
							id: 0,
							proId: 0,
							proIndex: index + 1,
							optionAnswer: v.optionAnswerArr[0]+"/"+v.optionAnswerArr[1],
							isAnswer: 1
						})
					}
				})
				if (detailList.filter(v => v.optionAnswer == '').length > 0) {
					this.$message("正确答案不能为空!");
					return
				}

			}
			this.addForm.proName = this.addForm.proRemark.replace(/<[^>]+>/g, '').replace('&nbsp;', '')
			this.$set(this.addForm, "detailList", detailList)
			this.$set(this.addForm, "bookVersionIds", this.bookVersionArr.join(','))
			let formData = this.$util.jsonToForm(this.addForm);
			this.$axios.post("/exercise/exerciseinfosave", formData).then(res => {
				if (res.data.status == 0) {
					this.$message("保存成功!");
					this.hanleClear()
					if(addType==2){
						this.selectAnswerList=[{ value: '', label: 'A' }, { value: '', label: 'B' }, { value: '', label: 'C' }, { value: '', label: 'D' }]
						this.inputAnserList=[]
						if(String(this.addForm.proType)=='0' || String(this.addForm.proType)=='1'){
							this.selectAnswerList.map((v,idx)=>{
								this.$refs["editor"+idx].setContent('')
							})
							this.isAnswerArr=[]
						}
					}
					this.$emit("saveCallBack",res.data.data,addType);
	
				} else {
					this.$message(res.data.msg);
				}
			});
		}
	},
	async created() {
		this.treeData=await this.getExerciseGroupTreeData(this.fromType)
		this.proTypeDict = (await this.getDictInfo('proType'))
		this.proLevelDict = (await this.getDictInfo('proLevel'))
		this.bookVersionDict = (await this.getDictInfo('bookVersion'))
	}
};
</script>

<style lang="scss" scoped>
.el-cascader-menu {
	height: auto !important;
}
</style>
